export default __webpack_public_path__ + "static/girls-glitter-white-5634d1cfdb1d8b875a465cbc6bf1e4be.gif";